/* Extracted from sections/holiday-notice.liquid (lines 1241-2187 of the 20 Oct 2026 live copy) by checks/split_inline_js.py.
   Same code, same position in the page; now a cached asset instead of inline HTML. */
    (function () {
      var overlay = document.getElementById('tc-holiday-notice');
      if (!overlay) return;
      var dialog = overlay.querySelector('.tc-holiday-notice');
      var MODE = overlay.getAttribute('data-mode') === 'signup' ? 'signup' : 'holiday';
      var UNTIL = overlay.getAttribute('data-until') || '';
      var DESIGN = overlay.hasAttribute('data-design-mode');
      /* Takeover: Circle + Subscribe & save re-skin of the sign-up mode. */
      var TK = MODE === 'signup' && overlay.hasAttribute('data-takeover');
      /* Black Friday takeover (31 Oct 2026): the same sign-up shown full screen on every
         device (never the phone sheet), with a countdown and an optional hair-goal chip
         that travels to Klaviyo as a profile property. */
      var BF = TK && overlay.hasAttribute('data-bf');
      var bfGoal = '';
      function bfProps() { var p = { 'Black Friday early access': true }; if (bfGoal) p['Hair goal'] = bfGoal; return p; }
      /* Welcome 15 (18 Oct): new key so visitors who saw Join 50 see the new pop-up once. */
      var KEY = MODE === 'signup' ? (TK ? 'tc_w15_seen' : 'tc_signup_seen') : 'tc_holiday_notice_seen';
      var SHOW_DELAY_MS = 1500;
      /* Sharper (18 Oct evening): about 4 s after landing or a 25% scroll,
         whichever comes first (1.5 s on a 2nd page view). */
      var TK_DELAY_MS = 4000;
      var TK_SCROLL = 0.25;
      var SIGNUP_QUIET_DAYS = TK ? 14 : 30;
      /* Owner, 31 Oct 2026: "Pop up should appear each new session." The
         takeover is now quiet for the rest of the visit only, not 14 days:
         a visit ends after 30 minutes with no page of the site loaded or
         left (Google Analytics' own rule), and the next visit shows it again.
         The mark is refreshed on every page view and when a page is left, so
         it never re-opens mid-visit. Signing up still ends it for good, and
         every other gate (ordered customers, email visits, Google landings,
         cookie choice first) is unchanged. */
      var VISIT_GAP_MS = 30 * 60 * 1000;
      /* The real Founding Fortnight end: 11.59pm Sun 25 Oct 2026 (GMT). */
      var TC_FF_END = 1792972740000;
      /* One "last call" re-show from Fri 23 Oct 2026 23:59 UTC to the end. */
      var TC_LAST_START = 1792799940000;
      var LAST_KEY = 'tc_takeover_lastcall';
      function inLastCall() { var n = Date.now(); return TK && n >= TC_LAST_START && n < TC_FF_END; }
      function isDesktop() { return !!(window.matchMedia && window.matchMedia('(min-width: 768px)').matches); }

      function londonToday() {
        try {
          var p = {};
          new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' })
            .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
          return p.year + '-' + p.month + '-' + p.day;
        } catch (e) { return ''; }
      }
      /* The page may be served from cache after the last paused day. */
      if (MODE === 'holiday' && !DESIGN && UNTIL && londonToday() > UNTIL) return;

      function getCookie(name) {
        var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
        return m ? decodeURIComponent(m[1]) : null;
      }
      /* Holiday: seen-flag keyed to the holiday's end date, so a future
         holiday shows again. Sign-up: quiet for 30 days after it was shown,
         and never again once the visitor has signed up. Session storage
         always; the persistent copy only once cookies have been accepted. */
      /* Fix pack (30 Oct 2026): a session cookie copy of the seen mark, so a
         visitor who never answers the cookie banner sees the pop-up once per
         visit rather than once per tab. It holds only a time, no identifier,
         and ends with the browser session (a UI-state cookie). */
      var SEEN_COOKIE = 'tc_w15_s', LAST_COOKIE = 'tc_w15_lc';
      function seen() {
        if (MODE === 'signup') {
          if (getCookie('tc_subscribed')) return true;
          /* Last-call window: only whether the last call was already shown counts. */
          if (inLastCall()) {
            if (getCookie(LAST_COOKIE)) return true;
            try { if (sessionStorage.getItem(LAST_KEY)) return true; } catch (e) {}
            try { if (localStorage.getItem(LAST_KEY)) return true; } catch (e) {}
            return false;
          }
          var now = Date.now(), quiet = TK ? VISIT_GAP_MS : SIGNUP_QUIET_DAYS * 864e5, v;
          v = +getCookie(SEEN_COOKIE); if (v && now - v < quiet) return true;
          try { v = +sessionStorage.getItem(KEY); if (v && now - v < quiet) return true; } catch (e) {}
          try { v = +localStorage.getItem(KEY); if (v && now - v < quiet) return true; } catch (e) {}
          return false;
        }
        try { if (sessionStorage.getItem(KEY) === UNTIL) return true; } catch (e) {}
        try { if (localStorage.getItem(KEY) === UNTIL) return true; } catch (e) {}
        return false;
      }
      function markSeen() {
        var val = MODE === 'signup' ? String(Date.now()) : UNTIL;
        var last = inLastCall();
        try { sessionStorage.setItem(KEY, val); if (last) sessionStorage.setItem(LAST_KEY, val); } catch (e) {}
        if (MODE === 'signup') {
          document.cookie = SEEN_COOKIE + '=' + val + '; path=/; SameSite=Lax; Secure';
          if (last) document.cookie = LAST_COOKIE + '=' + val + '; path=/; SameSite=Lax; Secure';
        }
        if (getCookie('tc_cookie_consent') === 'accepted') {
          try { localStorage.setItem(KEY, val); if (last) localStorage.setItem(LAST_KEY, val); } catch (e) {}
        }
      }
      /* Still in the visit that saw it: carry the mark forward. Never starts
         a mark (a visit that hasn't seen the takeover keeps its turn). */
      function touchVisit() {
        if (MODE !== 'signup' || !TK || getCookie('tc_subscribed') || inLastCall() || !seen()) return;
        markSeen();
      }
      window.addEventListener('pagehide', touchVisit);

      /* Cookies accepted after the pop-up was shown: keep the 30-day quiet
         period too (markSeen ran before the choice, so only sessionStorage
         had the mark). */
      document.addEventListener('tc:consent-granted', function () {
        try {
          var v = sessionStorage.getItem(KEY), l = sessionStorage.getItem(LAST_KEY);
          if (v) localStorage.setItem(KEY, v);
          if (l) localStorage.setItem(LAST_KEY, l);
        } catch (e) {}
      });

      /* Never over another dialog: search, cart drawer, mobile menu, the
         shared overlay, or the cookie banner. */
      /* Capture fix (30 Oct 2026): most visitors never answer the cookie
         banner, and the pop-up waited for that choice, so it hardly ever
         opened (2 real sign-ups in 11 days). The banner now has the first
         CHOICE_GRACE_MS of the pop-up's turn; after that the pop-up opens
         anyway. The banner stays on top (--z-cookie is above --z-popup) and
         on phones the sheet sits above it (dockedBottom), so both stay usable. */
      var CHOICE_GRACE_MS = 4500;
      var choiceWaitFrom = 0;
      /* The banner is revealed after two animation frames (none in a
         background tab), so key on the missing consent cookie rather than
         its .is-visible class — otherwise the two can stack. */
      function bannerUp() {
        var cb = document.querySelector('.tc-cookie');
        return !!cb && cb.style.display !== 'none' && !getCookie('tc_cookie_consent');
      }
      function cookieChoicePending() {
        if (!bannerUp()) return false;
        if (!choiceWaitFrom) choiceWaitFrom = Date.now();
        return Date.now() - choiceWaitFrom < CHOICE_GRACE_MS;
      }
      function isDialogOpen() {
        return cookieChoicePending() || !!document.querySelector(
          '#search-overlay:not([hidden]), [data-cart-drawer].is-open, .tc-cart-drawer.is-open, ' +
          '[data-mobile-nav].is-open, .tc-mobile-nav.is-open, .tc-overlay.is-active, .tc-overlay.is-open, ' +
          '.tc-exit-overlay.is-visible, ' +
          '[data-product-zoom-modal].is-open, .tc-gallery__lightbox.is-open'
        );
      }

      var lastFocus = null;
      var releaseFocus = null;
      var prevOverflow = '';
      var FOCUSABLE = 'button:not([disabled]), [href], input:not([type="hidden"]):not([disabled])';
      /* Sharper (18 Oct evening): on phones (<768px) the welcome pop-up is a
         NON-MODAL bottom sheet (Google's mobile interstitial guidance): no
         backdrop, no scroll lock, no focus trap; Escape and ✕ close it. Set
         per opening; desktop keeps the modal dialog. */
      var sheet = false;

      function onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab' || releaseFocus || sheet) return;
        var f = Array.prototype.slice.call(dialog.querySelectorAll(FOCUSABLE));
        /* Fix pack: while the cookie banner is unanswered its buttons are part
           of the Tab cycle, so keyboard users can always make the choice. */
        var cbEl = bannerUp() && document.querySelector('.tc-cookie');
        if (cbEl) f = f.concat(Array.prototype.slice.call(cbEl.querySelectorAll(FOCUSABLE)));
        f = f.filter(function (el) { return el.tabIndex >= 0 && !el.closest('[hidden]') && el.getClientRects().length > 0; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1], at = f.indexOf(document.activeElement);
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (at === -1) { e.preventDefault(); first.focus(); }
        else if (cbEl) { e.preventDefault(); f[(at + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus(); }
      }

      var usedScrollLock = false;
      function lockScroll() {
        var SL = TK && window.TheColor && window.TheColor.ScrollLock;
        if (SL && typeof SL.lock === 'function') {
          try { SL.lock('signup-popup'); usedScrollLock = true; return; } catch (e) {}
        }
        usedScrollLock = false;
        prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      function unlockScroll() {
        if (usedScrollLock) {
          try { window.TheColor.ScrollLock.unlock('signup-popup'); } catch (e) {}
          usedScrollLock = false;
          return;
        }
        document.body.style.overflow = prevOverflow;
      }

      /* Phones: sit ON TOP of the product page's sticky Add to basket bar
         (never over its button), following it as it slides in and out, and
         likewise above any other full-width bar docked at the bottom edge
         (a fixed element at most a quarter of the screen tall). */
      var liftObs = null;
      var liftRaf = 0;
      var liftLater = 0;
      function dockedBottom() {
        var vh = window.innerHeight, vw = window.innerWidth;
        var bar = document.querySelector('[data-sticky-atc-bar].is-visible');
        var h = bar ? bar.offsetHeight : 0;
        /* Fix pack: an unanswered cookie banner is always docked, whatever its
           height (landscape phones: it is over a quarter of the screen). */
        var cb = document.querySelector('.tc-cookie');
        if (bannerUp() && cb) {
          var cr = cb.getBoundingClientRect();
          if (cr.height > 0 && cr.bottom >= vh - 4) h = Math.max(h, Math.round(vh - cr.top));
        }
        if (!document.elementsFromPoint) return h;
        var els = document.elementsFromPoint(vw / 2, vh - 2);
        var done = [];
        for (var i = 0; i < els.length && i < 10; i++) {
          if (overlay.contains(els[i])) continue;
          var f = els[i];
          while (f && f !== document.body && f !== document.documentElement && getComputedStyle(f).position !== 'fixed') f = f.parentElement;
          /* reached the page itself: nothing else is docked there */
          if (!f || f === document.body || f === document.documentElement) break;
          if (done.indexOf(f) > -1) continue;
          done.push(f);
          /* a banner that has been answered is sliding out: it no longer counts */
          if (f.classList && f.classList.contains('tc-cookie') && !bannerUp()) continue;
          var r = f.getBoundingClientRect();
          if (r.width >= vw * 0.9 && r.bottom >= vh - 4 && r.height > 0 && r.height <= vh * 0.25) h = Math.max(h, Math.round(vh - r.top));
        }
        return h;
      }
      /* Fix pack: while the banner is unanswered the overlay knows its height,
         so the centred card leaves room for it (wide landscape phones) and
         short phone screens get a compact sheet. */
      function syncBanner() {
        var up = bannerUp(), cb = document.querySelector('.tc-cookie');
        overlay.classList.toggle('is-cookie-up', up);
        overlay.style.setProperty('--tc-cookie-h', (up && cb ? Math.round(cb.getBoundingClientRect().height) : 0) + 'px');
      }
      document.addEventListener('tc:consent-decided', function () {
        if (overlay.hidden) return;
        syncBanner();
        if (sheet) { placeSoon(); setTimeout(placeSheet, 650); }
      });
      function placeSheet() {
        liftRaf = 0;
        var h = dockedBottom();
        overlay.style.setProperty('--tc-w15-lift', h + 'px');
        overlay.classList.toggle('is-lifted', h > 0);
      }
      function placeSoon() {
        if (!liftRaf) liftRaf = requestAnimationFrame(placeSheet);
        /* and once more after a docked bar's own slide has finished */
        clearTimeout(liftLater);
        liftLater = setTimeout(placeSheet, 400);
      }
      /* a cookie choice made while the sheet is open drops the sheet back down */
      function onCookieTap(e) { if (e.target && e.target.closest && e.target.closest('.tc-cookie')) placeSoon(); }
      function watchLift(on) {
        if (on) {
          placeSheet();
          placeSoon();
          if (!liftObs && window.MutationObserver) {
            liftObs = new MutationObserver(placeSoon);
            liftObs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
          }
          window.addEventListener('resize', placeSoon);
          window.addEventListener('scroll', placeSoon, { passive: true });
          document.addEventListener('click', onCookieTap, true);
          return;
        }
        if (liftObs) { liftObs.disconnect(); liftObs = null; }
        window.removeEventListener('resize', placeSoon);
        window.removeEventListener('scroll', placeSoon);
        document.removeEventListener('click', onCookieTap, true);
        clearTimeout(liftLater);
      }

      /* Measurement (pipeline audit, 13 Oct 2026): the pop-up had no view or
         submit events, so its sign-up rate couldn't be read. Custom events go
         to Shopify's Customer events (Settings → Customer events → a custom
         pixel can subscribe to tc_popup_view / tc_popup_submit /
         tc_popup_signup / tc_popup_code_applied) and, after cookie consent
         only, to gtag. No email, name or other personal data is ever sent. */
      function track(name, extra) {
        if (DESIGN) return;
        var data = { popup: TK ? 'takeover' : MODE };
        if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) data[k] = extra[k]; } }
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish(name, data);
          }
        } catch (e) {}
        try {
          var u = window.TheColor && window.TheColor.utils;
          if (typeof window.gtag === 'function' && u && typeof u.hasConsent === 'function' && u.hasConsent()) {
            window.gtag('event', name, data);
          }
        } catch (e) {}
      }
      function popupState() {
        if (TK) return dialog.querySelector('[data-w15-done]:not([hidden])') ? 'done' : 'form';
        var st = dialog.querySelector('[data-su-state]');
        return st ? (st.getAttribute('data-su-state') || 'form') : 'form';
      }
      /* Someone typing in a page field when the sheet slides up keeps their focus. */
      function typingElsewhere() {
        var a = document.activeElement;
        return !!a && a !== document.body && !dialog.contains(a) &&
          (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable);
      }

      var hideTimer = null;
      function open(trigger) {
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; overlay.hidden = true; overlay.classList.remove('is-visible'); }
        if (!overlay.hidden) return;
        sheet = TK && !BF && !isDesktop();
        lastFocus = document.activeElement;
        overlay.classList.toggle('is-sheet', sheet);
        syncBanner();
        window.addEventListener('resize', syncBanner);
        /* the banner must stay reachable: no modal semantics or focus trap while it is unanswered */
        if (TK) dialog.setAttribute('aria-modal', (sheet || bannerUp()) ? 'false' : 'true');
        track('tc_popup_view', TK ? { state: popupState(), layout: sheet ? 'sheet' : 'dialog', trigger: trigger || 'auto' } : { state: popupState() });
        if (sheet) watchLift(true);
        overlay.hidden = false;
        if (!sheet) lockScroll();
        document.body.classList.add('tc-popup-open');
        if (TK) tick();
        requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
        if (!sheet && !bannerUp() && window.TheColor && typeof window.TheColor.trapFocus === 'function') {
          try { releaseFocus = window.TheColor.trapFocus(dialog) || null; } catch (e) { releaseFocus = null; }
        }
        /* after trapFocus (which focuses the first control, the ✕):
           holiday → the button; sign-up → the first field (or the error / thank-you button).
           Takeover: the thank-you title when it's done; otherwise phones
           focus the sheet itself (no keyboard popping up, and never taken
           from a field the shopper is typing in), desktop the email. */
        var target = null;
        var skipFocus = false;
        if (TK) {
          var doneOpen = dialog.querySelector('[data-w15-done]:not([hidden])');
          if (doneOpen) target = dialog.querySelector('[data-w15-title]');
          else if (sheet) { target = dialog; skipFocus = typingElsewhere(); }
          else target = dialog.querySelector('[aria-invalid="true"]') || dialog.querySelector('[data-su-email]');
          if (!doneOpen && !DESIGN && typeof prefetchCart === 'function') prefetchCart();
        } else if (MODE === 'signup') {
          target = dialog.querySelector('[aria-invalid="true"]') ||
            (dialog.querySelector('[data-su-state="success"]') ? dialog.querySelector('.tc-holiday-notice__cta') : dialog.querySelector('[data-su-name]'));
        }
        if (!skipFocus) (target || dialog.querySelector('.tc-holiday-notice__cta') || dialog).focus({ preventScroll: true });
        document.addEventListener('keydown', onKey);
        markSeen();
      }

      function isUsable(el) {
        return !!el && el !== document.body && typeof el.focus === 'function' &&
          document.contains(el) && !overlay.contains(el) && el.getClientRects().length > 0;
      }

      function close(opts) {
        if (overlay.hidden) return;
        var wasSheet = sheet;
        var hadFocus = dialog.contains(document.activeElement);
        overlay.classList.remove('is-visible');
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', syncBanner);
        if (typeof releaseFocus === 'function') { try { releaseFocus(); } catch (e) {} }
        releaseFocus = null;
        if (wasSheet) watchLift(false); else unlockScroll();
        document.body.classList.remove('tc-popup-open');
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(function () { hideTimer = null; overlay.hidden = true; }, 300);
        /* drop #join / #tc-signup-form so a reload doesn't re-open it */
        if ((location.hash === '#join' || location.hash === '#tc-signup-form') && window.history && history.replaceState) {
          try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) {}
        }
        /* The sheet never held the page: only hand focus back if it had it. */
        if ((opts && opts.keepFocus) || (wasSheet && !hadFocus)) return;
        /* back to the opener; if that's gone or hidden (e.g. the cookie banner), the main content */
        var back = isUsable(lastFocus) ? lastFocus : document.getElementById('main-content');
        if (back && typeof back.focus === 'function') back.focus({ preventScroll: true });
      }

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target.closest('[data-holiday-notice-close]')) close();
      });
      /* Phones: the cart drawer, menu, search or zoom opening (they all take
         TheColor.ScrollLock) puts the sheet away instead of covering them. */
      document.addEventListener('tc:scrolllock', function (e) {
        if (sheet && !overlay.hidden && e && e.detail && e.detail.locked) close({ keepFocus: true });
      });
      /* Logic review (18 Oct evening): the 15% taken in the basket's row
         (drawer or /cart) means the welcome pop-up has done its job, so its
         automatic opening stands down (this visit, and the quiet period). */
      var w15Elsewhere = false;
      /* FIRST15 / WELCOME15 on the basket, from the latest cart:updated (Google seamless). */
      var basketFirst = false;
      document.addEventListener('tc:welcome15', function (e) {
        if (TK && e && e.detail && e.detail.from === 'basket') { w15Elsewhere = true; markSeen(); }
      });

      /* An automatic opening (timer / scroll / exit / 2nd page) that had to
         wait for another dialog re-checks on the way out: it stands down if
         the visitor has since seen the pop-up or taken the 15% in the basket
         (logic review, 18 Oct: joining in the drawer, then closing it, re-
         opened the pop-up asking for the email again). A link / return that
         asks while it waits takes the wait over, so it still opens. */
      var AUTO_TRIGGERS = { timer: 1, scroll: 1, exit: 1, pageview: 1 };
      var waiting = false;
      var waitTrigger;
      /* UX review (18 Oct): at ~4 s a shopper may already be typing in a page
         field (e.g. the footer's email box); an automatic opening waits until
         they leave it (desktop would otherwise take their focus and lock the
         page). Links, /#join and the captcha return are never held back. */
      function typingBlocks(t) { return TK && !!AUTO_TRIGGERS[t] && typingElsewhere(); }
      function showWhenClear(trigger) {
        if (!isDialogOpen() && !typingBlocks(trigger)) { open(trigger); return; }
        if (!waiting || !AUTO_TRIGGERS[trigger]) waitTrigger = trigger;
        if (waiting) return;
        waiting = true;
        var poll = setInterval(function () {
          if (isDialogOpen() || typingBlocks(waitTrigger)) return;
          clearInterval(poll);
          setTimeout(function () {
            var t = waitTrigger;
            waiting = false;
            waitTrigger = undefined;
            if (TK && AUTO_TRIGGERS[t] && (w15Elsewhere || seen() || basketFirst)) return;
            showWhenClear(t);
          }, 1200);
        }, 1000);
      }

      /* Founding Fortnight countdown: days / hrs / mins only, ticks every
         60 s, never in a live region. At zero the double-points copy hides
         and the "after" copy shows (Liquid already renders the right state;
         this corrects cached pages). */
      function tcLeft(){var ms=TC_FF_END-Date.now();if(ms<=0)return null;var m=Math.floor(ms/60000);return{d:Math.floor(m/1440),h:Math.floor(m%1440/60),m:m%60};}
      function tcText(t){if(!t)return'';if(t.d>0)return t.d+(t.d===1?' day ':' days ')+t.h+(t.h===1?' hr':' hrs');if(t.h>0)return t.h+(t.h===1?' hr ':' hrs ')+t.m+(t.m===1?' min':' mins');return t.m+(t.m===1?' min':' mins');}
      function pad2(n) { return (n < 10 ? '0' : '') + n; }
      function each(sel, fn) { Array.prototype.forEach.call(overlay.querySelectorAll(sel), fn); }
      var tickTimer = null;
      function tick() {
        var t = tcLeft();
        if (!t) {
          each('[data-tc-ff]', function (el) { el.hidden = true; });
          each('[data-tc-ff-after]', function (el) { el.hidden = false; });
          if (tickTimer) { clearInterval(tickTimer); tickTimer = null; }
          return false;
        }
        var txt = tcText(t);
        each('[data-tc-left]', function (el) { el.textContent = txt; });
        each('[data-tc-d]', function (el) { el.textContent = pad2(t.d); });
        each('[data-tc-h]', function (el) { el.textContent = pad2(t.h); });
        each('[data-tc-m]', function (el) { el.textContent = pad2(t.m); });
        return true;
      }
      if (TK) {
        if (tick()) tickTimer = setInterval(tick, 60000);
      }

      if (MODE === 'signup') {
        var form = dialog.querySelector('form');
        var state = dialog.querySelector('[data-su-state]');
        var submitted = false;
        try { submitted = sessionStorage.getItem('tc_su_submitted') === '1'; sessionStorage.removeItem('tc_su_submitted'); } catch (e) {}
        /* The form posts to /contact#tc-signup-form, so the hash also marks
           "this pop-up was the form posted" (covers Shopify's captcha path). */
        if (TK && location.hash === '#tc-signup-form') submitted = true;

        function fieldMsg(input, text) {
          var msg = input && document.getElementById(input.getAttribute('aria-describedby') || '');
          if (input) input.setAttribute('aria-invalid', text ? 'true' : 'false');
          if (msg) { msg.textContent = text || ''; msg.hidden = !text; }
        }
        /* UK-friendly mobile → E.164 (+44…), which Shopify requires. */
        function normPhone(v) {
          var d = (v || '').replace(/[\s().-]/g, '');
          if (!d) return '';
          if (/^00/.test(d)) d = '+' + d.slice(2);
          if (/^0\d{9,10}$/.test(d)) d = '+44' + d.slice(1);
          if (/^44\d{9,10}$/.test(d)) d = '+' + d;
          return /^\+\d{10,15}$/.test(d) ? d : null;
        }

        var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        /* one line on a 375px phone, so the sheet barely grows (UX review, 18 Oct) */
        var BAD_EMAIL = 'Please enter a full email, e.g. name@example.com.';
        /* Welcome 15 helpers (also used by the /#join opener and when the
           visitor comes back from the captcha path with tc_w15_ok set). */
        var capped = function (ms) {
          var c = null;
          try { c = new AbortController(); } catch (e) {}
          var t = setTimeout(function () { if (c) c.abort(); }, ms);
          return { signal: c ? c.signal : undefined, done: function () { clearTimeout(t); } };
        };
        var up = function (s) { return String(s || '').toUpperCase(); };
        var setSubscribed = function () { document.cookie = 'tc_subscribed=1; path=/; max-age=31536000; SameSite=Lax; Secure'; };
        /* Klaviyo sign-up (19 Oct 2026): public client endpoint (company id
           only, no key), single opt-in "Email List" Y6RS7f, which triggers
           the Welcome flow. 202 = joined. No captcha. When marketing cookies
           are allowed, the browser is also identified, so basket reminders
           can reach them. */
        var klaviyoSub = function (email, source) {
          if (!window.fetch || !window.JSON) return Promise.resolve(false);
          var t = capped(6000);
          var payload = { data: { type: 'subscription', attributes: { custom_source: BF ? 'Pop-up Black Friday' : source, profile: { data: { type: 'profile', attributes: { email: email, properties: BF ? bfProps() : undefined, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: 'Y6RS7f' } } } } };
          return fetch('https://a.klaviyo.com/client/subscriptions?company_id=SKBdJj', { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' }, body: JSON.stringify(payload), signal: t.signal })
            .then(function (r) {
              t.done();
              var ok = r.status >= 200 && r.status < 300;
              if (ok) {
                try {
                  var cp = window.Shopify && window.Shopify.customerPrivacy;
                  var k = window.klaviyo;
                  if (cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() && k && typeof k.identify === 'function') {
                    var p = k.identify({ email: email });
                    if (p && typeof p.catch === 'function') p.catch(function () {});
                  }
                } catch (e) {}
              }
              return ok;
            })
            .catch(function () { t.done(); return false; });
        };
        /* true as soon as any of the promises gives true; false once all have
           settled without one. (The promises here never reject.) */
        var firstTrue = function (list) {
          return new Promise(function (resolve) {
            var left = list.length;
            list.forEach(function (p) {
              p.then(function (ok) { if (ok) resolve(true); else if (--left === 0) resolve(false); }, function () { if (--left === 0) resolve(false); });
            });
          });
        };
        /* What a /cart.js payload means here:
           { items, welcome: 'FIRST15' | 'WELCOME15' | null (WELCOME15, the
             code before 19 Oct 2026, still counts as the same 15% while it
             works: it applies, or nothing one-off is in yet), other: another
             code the shopper already has (e.g. from our emails) that FIRST15
             must never replace, cart } */
        var readCart = function (c, fallbackItems) {
          if (!c || typeof c.item_count !== 'number') return { items: !!fallbackItems, welcome: null, other: null, cart: null };
          var codes = (c.discount_codes || []).filter(function (d) { return d && d.code; });
          var oneOffIn = (c.items || []).some(function (i) { return i && !i.selling_plan_allocation && !i.gift_card; });
          var mine = codes.filter(function (d) { var k = up(d.code); return k === 'FIRST15' || (k === 'WELCOME15' && (!!d.applicable || !oneOffIn)); })
            .sort(function (a, b) { return (b.applicable ? 2 : 0) + (up(b.code) === 'FIRST15' ? 1 : 0) - (a.applicable ? 2 : 0) - (up(a.code) === 'FIRST15' ? 1 : 0); });
          var other = codes.filter(function (d) { var k = up(d.code); return k !== 'WELCOME15' && k !== 'FIRST15'; });
          return { items: c.item_count > 0, welcome: mine.length ? up(mine[0].code) : null, other: other.length ? String(other[0].code) : null, cart: c };
        };
        var itemsHint = function () { return (+overlay.getAttribute('data-j50-items') || 0) > 0; };
        var cartFetch = function () {
          if (!window.fetch) return Promise.resolve(readCart(null, itemsHint()));
          var t = capped(2500);
          return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: t.signal })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (c) { t.done(); return readCart(c, itemsHint()); })
            .catch(function () { t.done(); return readCart(null, itemsHint()); });
        };
        /* Speed: the basket state is read when the pop-up opens (or taken from
           the theme's own cart:updated), so on submit the only request in
           the way of "15% is on" is /discount/FIRST15 itself. */
        var pre = null;
        document.addEventListener('cart:updated', function (e) {
          var c = e && e.detail && e.detail.cart;
          pre = c && Array.isArray(c.discount_codes) ? { t: Date.now(), p: Promise.resolve(readCart(c, itemsHint())) } : null;
          if (pre) basketFirst = !!readCart(c).welcome;
        });
        var prefetchCart = function () {
          if (!pre || Date.now() - pre.t > 15000) pre = { t: Date.now(), p: cartFetch() };
          return pre.p;
        };
        var cartNow = function () {
          if (pre && Date.now() - pre.t < 60000) return pre.p;
          return prefetchCart();
        };
        /* /discount/CODE stores the code on this browser's basket and
           checkout, then redirects; redirect=/cart.js hands back the basket
           with the code priced in. Resolves the cart, or null. */
        var applyCode = function () {
          if (!window.fetch) return Promise.resolve(null);
          var t = capped(5000);
          return fetch('/discount/FIRST15?redirect=%2Fcart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, redirect: 'follow', signal: t.signal })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (c) { t.done(); return c && Array.isArray(c.discount_codes) ? c : null; })
            .catch(function () { t.done(); return null; });
        };
        /* The 15% on the basket, never replacing a code the shopper already has.
           → { state: 'on' | 'kept' | 'failed', code, other, items, cart, added } */
        var ensureCode = function () {
          /* the early read failed (timeout / offline): read once more before
             adding, so a code we couldn't see is never displaced (logic review) */
          return cartNow().then(function (st) { return st.cart ? st : cartFetch(); }).then(function (st) {
            if (st.welcome) return { state: 'on', code: st.welcome, items: st.items, cart: st.cart };
            if (st.other) return { state: 'kept', other: st.other, items: st.items, cart: st.cart };
            return applyCode().then(function (c) {
              var after = readCart(c, st.items);
              if (after.welcome) {
                pre = { t: Date.now(), p: Promise.resolve(after) };
                track('tc_popup_code_applied', { offer: 'welcome15', code: after.welcome });
                return { state: 'on', code: after.welcome, items: after.items, cart: c, added: true };
              }
              return { state: 'failed', items: st.items, cart: st.cart };
            });
          });
        };
        var money = function (p) {
          var u = window.TheColor && window.TheColor.utils;
          if (u && typeof u.formatMoney === 'function') { try { return u.formatMoney(p); } catch (e) {} }
          return '£' + (p / 100).toFixed(2);
        };
        /* This store prices the code at cart level (cart_level_discount_applications);
           line-level allocations are summed too, in case that ever changes. */
        var savingOf = function (c, code) {
          var sum = 0;
          (c.cart_level_discount_applications || []).forEach(function (a) {
            if (a && up(a.title || a.code) === code) sum += +a.total_allocated_amount || 0;
          });
          if (!sum) {
            (c.items || []).forEach(function (i) {
              ((i && i.line_level_discount_allocations) || []).forEach(function (d) {
                var app = d && d.discount_application;
                if (app && up(app.title || app.code) === code) sum += +d.amount || 0;
              });
            });
          }
          return sum;
        };
        var oneOffTotal = function (c) {
          var s = 0;
          (c.items || []).forEach(function (i) { if (i && !i.selling_plan_allocation && !i.gift_card) s += +(i.original_line_price != null ? i.original_line_price : i.line_price) || 0; });
          return s;
        };
        var doneCopy = function (res) {
          /* FIRST15 on the website (19 Oct 2026): every line names FIRST15. A
             basket that already held a working WELCOME15 keeps it and the
             copy names no code. */
          if (res.state === 'kept') return { title: 'FIRST15 is yours', line: 'Your basket already has ' + res.other + ', so we’ve kept it. Use FIRST15 at checkout instead if it saves you more.' };
          if (res.state !== 'on') return { title: 'FIRST15 is yours', line: 'Enter FIRST15 at checkout for 15% off your first order.' };
          var out = { title: res.code === 'FIRST15' ? 'FIRST15 is on your basket' : '15% off is on your basket', line: '15% comes off at checkout.' };
          var c = res.cart;
          if (!c) return out;
          var on = (c.discount_codes || []).some(function (d) { return d && up(d.code) === res.code && d.applicable; });
          if (on) {
            var s = savingOf(c, res.code);
            if (s > 0) out.line = 'You’re saving ' + money(s) + ' on this order.';
            return out;
          }
          var oneOff = oneOffTotal(c);
          if (c.item_count > 0 && !oneOff) { out.line = 'It takes 15% off one-off items. Subscribe & save has its own 15%.'; return out; }
          /* No minimum (19 Oct 2026), so no "reaches £20" line. */
          return out;
        };

        var BEST = '/collections/top-selling-products-purchased-by-our-regulars';
        var lastEmail = '';
        var lastRes = null;
        /* null: no sign-up sent this visit; true / false once the POST settles. */
        var signupOk = null;
        var paintConfirm = function () {
          var p = dialog.querySelector('[data-w15-confirm]');
          if (p) p.hidden = !(signupOk === false && lastEmail && lastRes);
        };
        var showDone = function (res) {
          var ask = dialog.querySelector('[data-w15-ask]');
          var head = dialog.querySelector('[data-w15-head]');
          var done = dialog.querySelector('[data-w15-done]');
          if (!done) return;
          lastRes = res;
          /* hold the card's height while its content swaps (no jump) */
          if (ask && !ask.hidden && !overlay.hidden && dialog.offsetHeight) dialog.style.minHeight = dialog.offsetHeight + 'px';
          var copy = doneCopy(res);
          var title = done.querySelector('[data-w15-title]');
          var line = done.querySelector('[data-w15-line]');
          if (title) title.textContent = copy.title;
          if (line) line.textContent = copy.line;
          overlay.setAttribute('data-w15-state', res.state);
          if (ask) ask.hidden = true;
          if (head) head.hidden = true;
          done.hidden = false;
          dialog.setAttribute('aria-labelledby', 'tc-w15-done-title');
          dialog.setAttribute('aria-describedby', 'tc-w15-done-line');
          var cta = done.querySelector('[data-w15-cta]');
          if (cta) {
            cta.href = res.items ? '/cart' : BEST;
            cta.textContent = res.items ? 'Go to my basket' : 'Shop best sellers';
          }
          paintConfirm();
          if (title && !overlay.hidden && (!sheet || dialog.contains(document.activeElement))) title.focus({ preventScroll: true });
          /* Repaint the basket (drawer, /cart, delivery bar, code row). */
          var Cart = window.TheColor && window.TheColor.Cart;
          if (!DESIGN && Cart && typeof Cart.init === 'function') { try { Cart.init(); } catch (e) {} }
          try { document.dispatchEvent(new CustomEvent('tc:welcome15', { detail: { applied: res.state === 'on', kept: res.state === 'kept', code: res.code || null, from: 'popup' } })); } catch (e) {}
        };
        /* Where the captcha path comes back to. */
        var backPath = function (toCart) {
          var back = toCart ? '/cart' : (location.pathname + location.search);
          if (back.charAt(0) !== '/' || back.charAt(1) === '/' || back.charAt(1) === '\\') back = '/';
          return back;
        };
        var codeUrl = function (toCart) { return '/discount/FIRST15?redirect=' + encodeURIComponent(backPath(toCart)); };
        /* Shopify's captcha path: the hidden real form, submitted so Shopify's
           script can add its token or show the challenge. The snippet at the
           top of this section then comes back (applying the code first only
           when it isn't on yet) and opens the thank-you state (tc_w15_ok). */
        var realPost = function (email, next) {
          var news = document.getElementById('tc-j50-news');
          var newsEmail = news && news.querySelector('[data-j50-news-email]');
          if (!news || !newsEmail || !email) return false;
          try { next.t = Date.now(); sessionStorage.setItem('tc_w15_next', JSON.stringify(next)); } catch (err) { return false; }
          newsEmail.value = email;
          try { if (news.requestSubmit) news.requestSubmit(); else news.submit(); return true; } catch (err) {
            try { sessionStorage.removeItem('tc_w15_next'); } catch (err2) {}
            return false;
          }
        };
        dialog.addEventListener('click', function (e) {
          var b = e.target.closest && e.target.closest('[data-w15-confirm-go]');
          if (!b || DESIGN) return;
          e.preventDefault();
          if (b.getAttribute('aria-busy') === 'true') return;
          track('tc_popup_confirm', { offer: 'welcome15' });
          var items = lastRes ? lastRes.items : itemsHint();
          b.setAttribute('aria-busy', 'true');
          /* Try Klaviyo again first (no captcha); the real form only if that
             still doesn't go through. */
          klaviyoSub(lastEmail, 'Pop-up FIRST15').then(function (kOk) {
            b.removeAttribute('aria-busy');
            if (kOk) {
              signupOk = true;
              setSubscribed();
              track('tc_popup_signup', { offer: 'welcome15' });
              paintConfirm();
              return;
            }
            var ok = lastRes && lastRes.state === 'failed'
              ? realPost(lastEmail, { u: codeUrl(items) })
              : realPost(lastEmail, { u: backPath(false), k: 1 });
            if (!ok) b.textContent = 'Please try again';
          });
        });

        if (form && TK && form.hasAttribute('data-j50-form')) {
          /* Welcome 15, sharper (18 Oct evening): the button is never
             disabled; the email is checked on submit. A valid email fires
             two requests at once: FIRST15 (since 19 Oct) onto the basket and the
             sign-up (Klaviyo Email List, plus the Shopify customer form with
             tags newsletter,signup-popup,welcome15).
             The thank-you state shows as soon as the code is on; the code no
             longer waits for, or depends on, the sign-up. If the sign-up isn't
             accepted (Shopify's hCaptcha), the 15% stays on and one small
             "Confirm my email" button runs the real form. */
          var jEmail = form.querySelector('[data-su-email]');
          var jBtn = form.querySelector('[data-su-submit]');
          var jLabel = jBtn ? jBtn.textContent : '';
          var busy = false;
          jEmail.addEventListener('input', function () {
            if (jEmail.getAttribute('aria-invalid') === 'true' && EMAIL_RE.test(jEmail.value.trim())) fieldMsg(jEmail, '');
          });
          /* Ready the basket state as soon as the shopper starts on the email. */
          jEmail.addEventListener('focus', function () { if (!DESIGN) prefetchCart(); });


        /* 21 Oct 2026: sign-up guard. Bots over Tor exit nodes were posting
           fake addresses (dotted-Gmail aliases, random business domains) into
           the sign-up. Before any Klaviyo or /contact call: honeypot empty,
           a trusted pointer/keyboard event has happened, 2.5 s since the
           script ran, no Gmail alias with 3+ dots, no disposable domain. A
           failed guard shows the normal thank-you and sends nothing. */
        var TC_GUARD = (function () {
          var t0 = Date.now(), human = false;
          var mark = function (ev) { if (ev && ev.isTrusted) human = true; };
          ['pointerdown', 'keydown', 'touchstart'].forEach(function (n) { try { document.addEventListener(n, mark, { capture: true, passive: true }); } catch (e) { document.addEventListener(n, mark, true); } });
          var DISPOSABLE = /@(mailinator|guerrillamail|10minutemail|temp-?mail|yopmail|sharklasers|trashmail|getnada|dispostable|maildrop|throwawaymail|fakeinbox|mohmal|tempr|emailondeck|mintemail)\./i;
          return function (email, form) {
            var hp = form && form.querySelector ? form.querySelector('input[name="tc_website"]') : null;
            if (hp && hp.value) return 'honeypot';
            if (!human) return 'no-interaction';
            if (Date.now() - t0 < 2500) return 'too-fast';
            var m = /^([^@]+)@(.+)$/.exec(String(email || '').trim());
            if (!m) return 'email';
            var local = m[1], dom = m[2].toLowerCase();
            if (/^(gmail|googlemail)\.com$/.test(dom) && local.split('.').length - 1 >= 3) return 'dotted-gmail';
            if (DISPOSABLE.test('@' + dom)) return 'disposable';
            return '';
          };
        })();
          var subscribe = function (email) {
            var why = TC_GUARD(email, form);
            if (why) { try { track('tc_popup_blocked', { why: why }); } catch (e) {} return Promise.resolve(true); }
            if (!window.fetch || !window.URLSearchParams) return Promise.resolve(false);
            var body = new URLSearchParams();
            body.append('form_type', 'customer');
            body.append('utf8', '✓');
            body.append('contact[email]', email);
            body.append('contact[accepts_marketing]', 'true');
            body.append('contact[tags]', 'newsletter,signup-popup,welcome15');
            var t = capped(4000);
            /* Success = Shopify redirected to ?customer_posted=true. A captcha
               challenge (/challenge), an error page or a timeout = not saved. */
            var shop = fetch('/contact', { method: 'POST', body: body, credentials: 'same-origin', redirect: 'follow', signal: t.signal })
              .then(function (r) { t.done(); var u = r.url || ''; return u.indexOf('/challenge') === -1 && /[?&]customer_posted=true/.test(u); })
              .catch(function () { t.done(); return false; });
            /* 19 Oct 2026: Shopify's captcha turns the /contact post away for
               most shoppers, which left them off the mailing list. Klaviyo
               (the "Email List" that starts the Welcome emails) is now the
               sign-up; /contact still runs alongside for the Shopify record.
               Either one landing counts as joined. */
            return firstTrue([klaviyoSub(email, 'Pop-up FIRST15'), shop]);
          };
          var resetBusy = function () {
            busy = false;
            jEmail.readOnly = false;
            if (jBtn) { jBtn.removeAttribute('aria-busy'); jBtn.textContent = jLabel; }
          };
          /* Back from the captcha page (bfcache) → usable again */
          window.addEventListener('pageshow', function (ev) { if (ev.persisted && busy) resetBusy(); });

          form.addEventListener('submit', function (e) {
            e.preventDefault();
            if (busy) return;
            var email = jEmail.value.trim();
            if (!EMAIL_RE.test(email)) { fieldMsg(jEmail, BAD_EMAIL); jEmail.focus(); return; }
            fieldMsg(jEmail, '');
            /* Theme editor: show the thank-you state, send nothing. */
            if (DESIGN) { showDone({ state: 'on', code: 'FIRST15', items: false, cart: null }); return; }
            busy = true;
            jEmail.readOnly = true;
            if (jBtn) { jBtn.setAttribute('aria-busy', 'true'); jBtn.textContent = 'Adding 15%…'; }
            track('tc_popup_submit', { offer: 'welcome15' });
            lastEmail = email;
            signupOk = null;
            var signup = subscribe(email).then(function (ok) {
              signupOk = ok;
              if (ok) { setSubscribed(); track('tc_popup_signup', { offer: 'welcome15' }); }
              else track('tc_popup_captcha_path', { offer: 'welcome15' });
              paintConfirm();
              return ok;
            });
            ensureCode().then(function (res) {
              if (res.state !== 'failed') { resetBusy(); showDone(res); return; }
              /* Rare: the background request couldn't add the code. Once the
                 sign-up has settled (so it isn't cut short), let the browser
                 add it and come back to the thank-you state. */
              signup.then(function (ok) {
                if (ok) {
                  try { sessionStorage.setItem('tc_w15_ok', '1'); } catch (err) {}
                  window.location.assign(codeUrl(res.items));
                  return;
                }
                if (realPost(email, { u: codeUrl(res.items) })) return;
                resetBusy();
                fieldMsg(jEmail, 'Sorry, that didn’t go through. Please try again in a moment.');
              });
            });
          });
        } else if (form) {
          form.addEventListener('submit', function (e) {
            var name = form.querySelector('[data-su-name]');
            var email = form.querySelector('[data-su-email]');
            var phone = form.querySelector('[data-su-phone]');
            var sms = form.querySelector('[data-su-sms]');
            var tags = form.querySelector('[data-su-tags]');
            var ok = true;
            fieldMsg(email, '');
            if (phone) fieldMsg(phone, '');
            if (!name.value.trim()) { name.setAttribute('aria-invalid', 'true'); ok = false; } else { name.setAttribute('aria-invalid', 'false'); }
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) { fieldMsg(email, 'Please enter a valid email address.'); ok = false; }
            var ph = phone ? normPhone(phone.value) : '';
            if (phone && ph === null) { fieldMsg(phone, 'Please enter a UK mobile number, e.g. 07700 900123 — or leave it blank.'); ok = false; }
            if (!ok) {
              e.preventDefault();
              var bad = form.querySelector('[aria-invalid="true"]');
              if (bad) bad.focus();
              return;
            }
            /* Full name → first + last name */
            var parts = name.value.trim().replace(/\s+/g, ' ').split(' ');
            name.value = parts.shift();
            if (parts.length) {
              var ln = form.querySelector('input[name="contact[last_name]"]') || document.createElement('input');
              ln.type = 'hidden'; ln.name = 'contact[last_name]'; ln.value = parts.join(' ');
              form.appendChild(ln);
            }
            if (phone) {
              if (ph) { phone.value = ph; } else { phone.removeAttribute('name'); }
            }
            if (sms && sms.checked && ph && tags && tags.value.indexOf('sms-optin') === -1) tags.value += ',sms-optin';
            try { sessionStorage.setItem('tc_su_submitted', '1'); } catch (err) {}
            track('tc_popup_submit');
          });
        }

        /* Already joined (18 Oct): skip the email step. Put FIRST15 on
           (unless the basket already has 15% or another code) and open
           straight onto the thank-you state. */
        var openJoin = function (trigger) {
          if (TK && getCookie('tc_subscribed')) {
            ensureCode().then(function (res) { showDone(res); showWhenClear(trigger); });
            return;
          }
          showWhenClear(trigger);
        };
        /* "/#join" links (e.g. the announcement bar) open the sign-up. */
        document.addEventListener('click', function (e) {
          var a = e.target.closest && e.target.closest('a[href$="#join"], [data-open-signup]');
          if (!a || DESIGN) return;
          e.preventDefault();
          openJoin('link');
        });

        if (!DESIGN) {
          var w15ok = false;
          try { w15ok = TK && sessionStorage.getItem('tc_w15_ok') === '1'; if (w15ok) sessionStorage.removeItem('tc_w15_ok'); } catch (e) {}
          if (w15ok) {
            /* Back from the captcha path: joined, and the code is on (or kept). */
            signupOk = true;
            var goDone = function () { ensureCode().then(function (res) { showDone(res); showWhenClear('return'); }); };
            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', goDone, { once: true }); else goDone();
            return;
          }
          if (state && submitted) {
            if (state.getAttribute('data-su-state') === 'success') {
              document.cookie = 'tc_subscribed=1; path=/; max-age=31536000; SameSite=Lax; Secure';
              track('tc_popup_signup');
            } else {
              track('tc_popup_error');
            }
            var go = function () { showWhenClear(); };
            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go, { once: true }); else go();
            return;
          }
          if (location.hash === '#join') {
            var goHash = function () { openJoin('link'); };
            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', goHash, { once: true }); else goHash();
            return;
          }
        }
      }

      /* Takeover: count page views this session (the 2nd one is a trigger). */
      var pageViews = 0;
      if (TK && !DESIGN) {
        try { pageViews = (+sessionStorage.getItem('tc_takeover_pv') || 0) + 1; sessionStorage.setItem('tc_takeover_pv', String(pageViews)); } catch (e) {}
      }

      if (!DESIGN && seen()) { touchVisit(); return; }

      if (DESIGN) {
        document.addEventListener('shopify:section:select', function (e) {
          if (e.target && e.target.contains(overlay)) open('editor');
        });
        document.addEventListener('shopify:section:deselect', function (e) {
          if (e.target && e.target.contains(overlay)) close();
        });
        return;
      }

      /* Timed from DOM ready, not window load: on a slow connection the load
         event waits for every image and could hold the notice back for ages. */
      function startTimed() { setTimeout(showWhenClear, SHOW_DELAY_MS); }

      /* Takeover, sharper (18 Oct evening; was 20 s / 12 s / 40% scroll and
         never on landing): auto-open on the FIRST of about 4 s after landing
         (counted from navigation start), a scroll of 25% of the page, or
         desktop exit intent (pointer leaves the top edge, after 2 s); on a
         2nd page view this session, 1.5 s. Phones get the non-blocking
         sheet, so this stays within Google's mobile interstitial guidance.
         The cookie choice and any open dialog still come first
         (showWhenClear waits for them). */
      function sinceLanding() {
        try { if (window.performance && typeof performance.now === 'function') return performance.now(); } catch (e) {}
        return 0;
      }
      function startTakeover() {
        /* Welcome 15 (18 Oct): visitors from our emails already have their
           own code, and joining would swap it for FIRST15, so the pop-up
           never opens by itself for them (this visit). The bar link still opens it. */
        var fromEmail = /[?&](utm_source=klaviyo|utm_medium=email)(&|$)/i.test(location.search);
        try {
          if (fromEmail) sessionStorage.setItem('tc_from_email', '1');
          else if (sessionStorage.getItem('tc_from_email') === '1') fromEmail = true;
        } catch (e) {}
        if (fromEmail) return;
        /* Zero friction (18 Oct): Google landings get the 15% on the basket
           (tc-g15 above), so the pop-up never opens by itself for them, on
           the landing page or for the rest of the visit. */
        var adLand = window.__tcG15Land.test(location.search);
        try { if (sessionStorage.getItem('tc_g15')) adLand = true; } catch (e) {}
        if (adLand) return;
        var desk = isDesktop();
        var fired = false;
        var timer = null;
        function cleanup() {
          if (timer) clearTimeout(timer);
          window.removeEventListener('scroll', onScroll);
          document.removeEventListener('mouseout', onOut);
        }
        function fire(trigger) {
          if (fired) return;
          fired = true;
          cleanup();
          if (w15Elsewhere || seen()) return;
          /* Google seamless (18 Oct night): 15% already on the basket (FIRST15
             from a Google visit in another tab or on an earlier day, or a
             WELCOME15 that still works) means there is nothing to ask for. */
          /* Review (18 Oct night): read the basket afresh unless the theme's own
             copy is under 2 s old; a Google click in another tab can put
             FIRST15 on after this page loaded, and the pop-up then asked for
             an email anyway. */
          var st0 = (pre && Date.now() - pre.t < 2000) ? pre.p : (pre = { t: Date.now(), p: cartFetch() }).p;
          st0.then(function (st) { if (!st.welcome) showWhenClear(trigger); });
        }
        function onScroll() {
          var max = document.documentElement.scrollHeight - window.innerHeight;
          if (max > 0 && (window.pageYOffset || document.documentElement.scrollTop || 0) >= max * TK_SCROLL) fire('scroll');
        }
        function onOut(e) {
          if (!e.relatedTarget && e.clientY < 10 && sinceLanding() >= 2000) fire('exit');
        }
        /* Desktop: fetch the bottles photo shortly before the card can open, so it never pops in. */
        if (desk) {
          var img = dialog.querySelector('.tc-j50__img');
          if (img) setTimeout(function () { try { img.loading = 'eager'; } catch (e) {} }, 1200);
        }
        if (BF) {
          var bfAll = function (sel, fn) { Array.prototype.forEach.call(dialog.querySelectorAll(sel), fn); };
          /* the takeover photo is desktop-only: the desk preload above already covers it */
          /* v2: the hair goal is asked on the thank-you screen (after the reward), and saved
             to the shopper's Klaviyo profile through the public client profile endpoint. */
          var bfSaveGoal = function (goal) {
            var inp = dialog.querySelector('[data-su-email]');
            var em = inp && String(inp.value || '').trim();
            if (!em || !window.fetch) return;
            try {
              fetch('https://a.klaviyo.com/client/profiles/?company_id=SKBdJj', {
                method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' },
                body: JSON.stringify({ data: { type: 'profile', attributes: { email: em, properties: { 'Hair goal': goal, 'Black Friday early access': true } } } })
              }).catch(function () {});
            } catch (e) {}
          };
          bfAll('[data-bf-goal]', function (b) {
            b.addEventListener('click', function () {
              bfAll('[data-bf-goal]', function (o) { o.setAttribute('aria-pressed', 'false'); });
              b.setAttribute('aria-pressed', 'true');
              bfGoal = b.getAttribute('data-bf-goal') || '';
              var ok = dialog.querySelector('[data-bf-goal-ok]'), nm = dialog.querySelector('[data-bf-goal-name]');
              if (nm) nm.textContent = bfGoal;
              if (ok) ok.hidden = false;
              bfSaveGoal(bfGoal);
              track('tc_popup_goal', { goal: bfGoal });
            });
          });
          var bfBox = dialog.querySelector('[data-bf-count]');
          var bfT = bfBox ? (+bfBox.getAttribute('data-bf-target') || 0) * 1000 : 0;
          var bfSet = function (sel, v) { var e = dialog.querySelector(sel); if (e && e.textContent !== v) e.textContent = v; };
          var bfTick = function () {
            if (!bfT) return;
            var left = Math.max(0, Math.floor((bfT - Date.now()) / 1000));
            if (!left) {
              bfAll('[data-bf-before]', function (e) { e.hidden = true; });
              bfAll('[data-bf-after]', function (e) { e.hidden = false; });
              return;
            }
            var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
            bfSet('[data-bf-d]', String(Math.floor(left / 86400)));
            bfSet('[data-bf-h]', p2(Math.floor(left % 86400 / 3600)));
            bfSet('[data-bf-m]', p2(Math.floor(left % 3600 / 60)));
            bfSet('[data-bf-s]', p2(left % 60));
          };
          bfTick();
          setInterval(function () { if (!overlay.hidden) bfTick(); }, 1000);
        }
        /* Home page (20 Oct 2026): never over the hero on arrival. The sheet
           waits for the first scroll that takes the hero off the screen, or
           for 3 s of quiet after the first tap, swipe or key on the stage and
           its dock. Same sheet, same once-per-visitor rule, and the cookie
           choice still comes first (showWhenClear). No timer, 2nd-page or
           exit-intent opening on the home page; other pages keep them. */
        if (overlay.hasAttribute('data-home-wait')) {
          AUTO_TRIGGERS.home_scroll = 1;
          AUTO_TRIGGERS.home_stage = 1;
          var hHero = document.querySelector('[data-tcs]') || document.querySelector('.tc-hero-homepage');
          var hStage = hHero && hHero.hasAttribute('data-tcs') ? hHero : null;
          var hQuiet = null;
          var hDone = false;
          var hGone = function () {
            if (!hHero) return (window.pageYOffset || 0) > window.innerHeight;
            var top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tc-fixed-top')) || 0;
            return hHero.getBoundingClientRect().bottom <= top + 1;
          };
          var hFire = function (t) {
            if (hDone) return;
            hDone = true;
            clearTimeout(hQuiet);
            window.removeEventListener('scroll', hScroll);
            if (hStage) { hStage.removeEventListener('pointerdown', hTouch, true); hStage.removeEventListener('keydown', hTouch, true); }
            fire(t);
          };
          var hScroll = function () { if (hGone()) hFire('home_scroll'); };
          var hTouch = function () { clearTimeout(hQuiet); hQuiet = setTimeout(function () { hFire('home_stage'); }, 3000); };
          window.addEventListener('scroll', hScroll, { passive: true });
          if (hStage) { hStage.addEventListener('pointerdown', hTouch, true); hStage.addEventListener('keydown', hTouch, true); }
          return;
        }
        if (pageViews >= 2) { timer = setTimeout(function () { fire('pageview'); }, SHOW_DELAY_MS); return; }
        timer = setTimeout(function () { fire('timer'); }, Math.max(600, TK_DELAY_MS - sinceLanding()));
        window.addEventListener('scroll', onScroll, { passive: true });
        if (desk && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          document.addEventListener('mouseout', onOut);
        }
      }

      var start = TK ? startTakeover : startTimed;
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
      else start();
    })();
